import { type UserList, createUserList } from 'models';
import { useMutation } from 'query';
import { getProgramUsersAutocomplete } from '../../services';

export const useProgramUsersAutocompleteMutation = () =>
  useMutation<UserList[], { limit?: number; programIds: string[]; search?: string }>({
    async mutationFn({ limit, programIds, search }) {
      const { data: users } = await getProgramUsersAutocomplete({
        config: {
          params: {
            limit,
            program_ids: programIds,
            scope: 'programs',
            search,
          },
        },
      });

      return users.map((user) => createUserList(user));
    },
  });
